import "../styles/TextCard.css";

export default function TextCard({
  title,
  description,
  titlePosition,
  height,
}) {
  return (
    <div className="text-card">
      <h2 className={`text-card-title ${titlePosition}`}>{title}</h2>
      <p className="text-card-description" style={{ height }}>
        {description}
      </p>
    </div>
  );
}
